import { createContext } from 'react';

export const Context = createContext<ContextProps>({
	setMode: () => {},
	showSubscribe: false,
	setShowSubscribe: () => {},
	setShowInstallation: () => {},
});

interface ContextProps {
	mode?: Mode;
	setMode: (mode: Mode) => void;
	showSubscribe: boolean;
	setShowSubscribe: (value: boolean) => void;
	setShowInstallation: (value: boolean) => void;
}

export type Mode = 'issues' | 'collections';
